<template>
    <div class="modal-loader modal-mask">
        <div class="block">
            <div class="wrapper">
                <div class="dual-ring"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        hide() {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        }
    }
}
</script>

<style lang="scss">
@import '../scss/Variables.scss';

.modal-loader {
    .block {
        display: table;
        width: 100%;
        height: 100%;

        .wrapper {
            display: table-cell;
            vertical-align: middle;
            text-align: center;
        }
    }

    .dual-ring {
        display: inline-block;
        width: 64px;
        height: 64px;

        &:after {
            content: " ";
            display: block;
            width: 40px;
            height: 40px;
            margin: 1px;
            border: 3px solid #fff;
            border-color: #fff transparent #fff transparent;
            animation: dualRing 0.3s linear infinite;
            @include borderRadius(50%);
        }
    }
}

@keyframes dualRing {
    0% {
        @include transformObject(rotate(0deg));
    }
    100% {
        @include transformObject(rotate(360deg));
    }
}
</style>